import { render, staticRenderFns } from "../../templates/form/farm-data-upload-form.pug?vue&type=template&id=1afbfc41&lang=pug&"
import script from "./FarmDataUploadForm.vue?vue&type=script&lang=js&"
export * from "./FarmDataUploadForm.vue?vue&type=script&lang=js&"
import style0 from "./FarmDataUploadForm.vue?vue&type=style&index=0&id=1afbfc41&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports